module.exports = Promise.all([parcelRequire.load("tNJpX"), parcelRequire.load("5wDx5"), parcelRequire.load("6dl67")]).then(() => parcelRequire('025EY'));